import styled from 'styled-components';

export const SegmentWrapper = styled.div<any>`
  width: 100%;
  // @ts-ignore
	max-width: ${props => props.maxWidth ? props.maxWidth : '100%'};
`;
